import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when a connected integration is disconnected from the account integrations page',
  name: 'integration_disconnected',
  params: [
    {
      description: 'The ID of the integration',
      name: 'integration_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The name of the integration',
      name: 'integration_name',
      required: true,
      type: 'string',
    },
    {
      description: 'The location where the integration was disconnected',
      name: 'trackLocation',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
